
import React, { useState } from "react";
import "../styles.css";
import "./credit-card.css";
import ReactModal from "react-modal";
import { BoxModal } from "../../../../components/boxModal";
import { FilterButton } from "../../../../components/E-check/style";
import { toast } from "react-toastify";
import { getApiErrorMessage } from "../../../../utils/getApiErrorMessage";

export const CardDelectionModal = ({ handleDeletion, setModalDeletion, modalDeletion, cardId, listCards }) => {
  const [Loader, setLoader] = useState(false);
  const handleCardDeletion = async () => {
    try {
      setLoader(true);
      await handleDeletion(cardId);
      await listCards();
      setModalDeletion(false);
    } catch (error) {
      console.log(error);
      toast.error(getApiErrorMessage(error, 'Erro ao excluir cartão'));
    } finally {
      setLoader(false);
    }
  }

  return (
    <ReactModal
      isOpen={modalDeletion}
      className="change-modal"
      overlayClassName="overlay-pix-modal"
    >
      <BoxModal
        title="Confirmação de Exclusão"
        close={() => setModalDeletion(false)}
        maxWidth={400}
      >
        <div className="credit-card-container">
          <div
            className="card-form-section"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: "1rem",
            }}
          >
              <p>Tem certeza que deseja remover este cartão? Esta ação não pode ser desfeita.</p>
          </div>

          {/* BOTÕES */}
          <div className="row mt-4 align-items-center justify-content-start btn-area">
            <div className="col-md-3 button-area">
              {Loader ? (
                <FilterButton
                  disabled
                >
                  <span className="sr-only">Loading...</span>
                </FilterButton>
              ) : (
                <FilterButton
                  onClick={() => handleCardDeletion(cardId)}
                >
                  Concluir
                </FilterButton>
              )}

              <button
                type="button"
                className="btn btn-secondary w-44 ml-2"
                onClick={() => setModalDeletion(false)}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </BoxModal>
    </ReactModal>
  );
};
